var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',{style:(_vm.fontStyle),on:{"click":function($event){return _vm.selectFont(_vm.font.index)}}},[_vm._v(" "+_vm._s(_vm.font.family)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }